export const ROUTES = {
  LOGIN: '/login',
  MAGIC_LINK: '/magic-link/:token',
  REGISTER: '/register',
  REGISTER_BRANCH: '/register-branch',
  CHANGE_PASSWORD: '/change-password',

  DASHBOARD: '/dashboard',
  ORDERS: '/orders',
  STAFF_ORDER_DETAIL: '/orders/:id',
  RECEIVING: '/receiving',
  INVENTORY: '/inventory',
  DELIVERY_SHEET: '/delivery-sheets/:id',
  SCANNER: '/scanner',
  SETTINGS: '/settings',
  BILLING: '/billing',

  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_BRANCHES: '/admin/branches',
  ADMIN_APPLICATIONS: '/admin/applications',
  ADMIN_USERS: '/admin/users',

  MY_ORDERS: '/my-orders',
  ORDER_DETAIL: '/my-orders/:id',
  NOTIFICATIONS: '/my-notifications',
  PROFILE: '/my-profile',

  NOT_FOUND: '*',
} as const;
